export const delay = async () =>
  // wait a little to show loading indicator, not just a glint
  new Promise(resolve => {
    setTimeout(resolve, 500);
  });
